/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */
var getIndexModule = require('../../../io/' + process.env.APP_ENV + '/getIndexModule');
var sio = require('../sio');
module.exports = function (inOpt) {
    var opts = inOpt || {};
    var success = opts.success;
    var data = inOpt.data || {};
    var query = data.query || {};
    // sio.ajax({
    //     cmd:'index/module',
    //     success:function(inResp){
    //         success.call(opts.scope, {
    //             content:{
    //                 initData:{
    //                     carouselList:inResp.carouselList || [],
    //                     seriesList:inResp.seriesList || [],
    //                     storyList:[{
    //                         "id": 1, // 故事ID
    //                         "title": "灵感起源", //标题
    //                         "subTitle": "探寻A.R.T.西区灵感起源", //副标题
    //                         "imgUrl": 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/page/story/s1.png?x-image-process=image/resize,m_fill,h_225,w_400' ,//图片  ./image/mockup/story/s1.png
    //                         'linkUrl':'storyArticle.html?id=1'
    //                     }, {
    //                         "id": 2, // 故事ID
    //                         "title": "艺术风格", //标题
    //                         "subTitle": "感触A.R.T.西区艺术格调", //副标题
    //                         "imgUrl": 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/page/story/s2.jpg?x-image-process=image/resize,m_fill,h_225,w_400', //图片 ./image/mockup/story/s2.jpg
    //                         'linkUrl':'storyArticle.html?id=2'
    //                     }, {
    //                         "id": 3, // 故事ID
    //                         "title": "西区原住民", //标题
    //                         "subTitle": "入驻A.R.T.西区自由领地", //副标题
    //                         "imgUrl": 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/page/story/s3.jpg?x-image-process=image/resize,m_fill,h_225,w_400',//图片./image/mockup/story/s3.jpg
    //                         'linkUrl':'boong.html'
    //                     }]
    //                 }
    //             }
    //         });
    //     }
    // });
    getIndexModule({
        scope: this,
        success: function (resp) {
            success.call(opts.scope, {
                content:{
                    initData:{
                        carouselList:resp.carouselList || [],
                        seriesList:resp.seriesList || [],
                        // storyList:[{
                        // //     "id": 5, // 故事ID
                        // //     "title": "多样礼遇 暑你有样", //标题
                        // //     "subTitle": "多件购享优惠，多款单品享一口价", //副标题
                        // //     "imgUrl": './image/mockup/story/s5.jpg' ,//图片  ./image/mockup/story/s1.png
                        // //     'linkUrl':'https://mp.weixin.qq.com/s/Xdwb-CgkDpfsaLqRubnNdg'
                        // // // },{
                        // //     "id": 4, // 故事ID
                        // //     "title": "自由世界，就要有样", //标题
                        // //     "subTitle": "美克家居A.R.T.西区登陆全国23城", //副标题
                        // //     "imgUrl": './image/mockup/story/s4.jpg' ,//图片  ./image/mockup/story/s1.png
                        // //     'linkUrl':'https://mp.weixin.qq.com/s/fY9q4cIQM0jdZtsD7QHjsA'
                        // // },{
                        //     "id": 1, // 故事ID
                        //     "title": "灵感起源", //标题
                        //     "subTitle": "探寻A.R.T.西区灵感起源", //副标题
                        //     "imgUrl": 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/page/story/s1.png?x-image-process=image/resize,m_fill,h_352,w_600,limit_0' ,//图片  ./image/mockup/story/s1.png
                        //     'linkUrl':'storyArticle.html?id=1'
                        // }, {
                        //     "id": 2, // 故事ID
                        //     "title": "艺术风格", //标题
                        //     "subTitle": "感触A.R.T.西区艺术格调", //副标题
                        //     "imgUrl": 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/page/story/s2.jpg?x-image-process=image/resize,m_fill,h_352,w_600,limit_0', //图片 ./image/mockup/story/s2.jpg
                        //     'linkUrl':'storyArticle.html?id=2'
                        // }, {
                        //     "id": 3, // 故事ID
                        //     "title": "西区原住民", //标题
                        //     "subTitle": "入驻A.R.T.西区自由领地", //副标题
                        //     "imgUrl": 'https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/page/story/s3.jpg?x-image-process=image/resize,m_fill,h_352,w_600,limit_0',//图片./image/mockup/story/s3.jpg
                        //     'linkUrl':'boong.html'
                        // }]
                    }
                }
            });

        }
    });
};



//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/index/getPageData.js
// module id = 406
// module chunks = 1